export default __webpack_public_path__ + "static/media/img_publi2.03b2edca.svg";